<div [ngClass]="{'bg-opacity-modal': menuMarcacionOpened}"></div>
<h1 mat-dialog-title id="novedades-dialog-title" class="titulo-modal">
  <span>{{ titulo }}</span>
  <button type="button" class="btn-close" aria-label="Cerrar" (click)="cerrarModal()">
    <mat-icon aria-hidden="true">close</mat-icon>
  </button>
</h1>
<div mat-dialog-content class="modal-marcacion-contenido novedades-dialog-body">

  <section class="empleado-card" aria-label="Datos del empleado">
    <div class="empleado-legajo-badge" [attr.aria-label]="'Legajo ' + objeto.IdLegajo">
      <span class="legajo-label">Legajo</span>
      <span class="legajo-number">{{ objeto.IdLegajo }}</span>
    </div>
    <div class="empleado-identidad">
      <span class="empleado-nombre">{{ objeto.Nombre + ' ' + objeto.Apellido }}</span>
    </div>
  </section>

  <section class="info-empleado" aria-label="Datos de la jornada">
    <div class="dato-diario">
      <span class="dato-etiqueta">Sección</span>
      <span class="dato-valor">{{ objeto.Seccion }}</span>
    </div>
    <div class="dato-diario">
      <span class="dato-etiqueta">Fecha</span>
      <span class="dato-valor">{{ objeto.FechaDate | date:'dd/MM/yyyy' }}</span>
    </div>
    <div class="dato-diario">
      <span class="dato-etiqueta">Jornada</span>
      <span class="dato-valor">{{ objeto.Njornada }}</span>
    </div>
    <div class="dato-diario">
      <span class="dato-etiqueta">Movimientos</span>
      <span class="dato-valor">{{ calcularMovimientos() || '—' }}</span>
    </div>
  </section>

  <mat-tab-group mat-stretch-tabs class="mb-2 mat-elevation-z4 tabs-parte-diario">
    <mat-tab label="Jornadas">
      <div class="tab-contenido">
        <div class="row">
          <div class="col-6 jornada-selector">
            <mat-form-field class="w-100">
              <mat-label>Seleccione jornada</mat-label>
              <input type="text" placeholder="" aria-label="Seleccione Jornada" matInput [formControl]="myControl"
                [matAutocomplete]="auto">
              <mat-autocomplete autoActiveFirstOption class="novedades-touch-autocomplete-panel" #auto="matAutocomplete"
                (optionSelected)="getSeleccionJornada($event)" [displayWith]="displayFn">
                <mat-option *ngFor="let item of filteredOptions | async" [matTooltip]="item.Detalle" [value]="item">
                  {{ item.Detalle }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>
          <div class="col-12 jornada-acciones">
            <button mat-flat-button color="primary" type="button" class="nov-btn-guardar" [disabled]="isBtnGuardarJornada" (click)="openModalData('jornada')">Guardar</button>
          </div>
        </div>
      </div>
    </mat-tab>
    <mat-tab label="Marcaciones">
      <div class="tab-contenido">
        <div class="row mb-3 justify-content-center">
          <div class="col-6 marcacion-controles">
            <div class="mr-5">
              <button [disabled]="!setHorarioHabilitado" (click)="toggleHorarioHabilitado()" mat-mini-fab color="accent"
                aria-label="Add" class="mr-3">
                <mat-icon>add</mat-icon>
              </button>
              <button [disabled]="isBtnAnularMarcacion" [matMenuTriggerFor]="menu"
                (menuOpened)="toggleMarcacionMenuOpened()" (menuClosed)="toggleMarcacionMenuOpened()" mat-mini-fab
                color="primary" aria-label="Remove">
                <mat-icon>remove</mat-icon>
              </button>
              <mat-menu #menu="matMenu" class="p-3 text-center menu-marcacion">
                <p>¿Anular marcación?</p>
                <button cdkFocusInitial mat-stroked-button color="primary" class="m-2"
                  (click)="anularMarcacion()">Si</button>
                <button mat-stroked-button class="m-2">No</button>
              </mat-menu>
            </div>
            <app-timepicker [isDisabled]="setHorarioHabilitado" [setDarkMode]="true"
              (timePickerEmit)="getTimePickerValue($event)" [tiempoActual]="tiempoActualReset"></app-timepicker>
          </div>
          <div class="col-2 marcacion-guardar">
            <button mat-flat-button color="primary" type="button" class="nov-btn-guardar" (click)="openModalData('marcacion')"
              [disabled]="isBtnGuardarMarcacion">Guardar</button>
          </div>
        </div>
        <div class="tabla-scroll">
          <table mat-table [dataSource]="dataSourceMarcacion" class="mat-elevation-z8 table-parte-diario">
            <ng-container matColumnDef="Hora">
              <th mat-header-cell *matHeaderCellDef> Hora </th>
              <td mat-cell *matCellDef="let element"> {{element.Hora}} </td>
            </ng-container>

            <ng-container matColumnDef="Tipo Marcación">
              <th mat-header-cell *matHeaderCellDef> Tipo Marcación </th>
              <td mat-cell *matCellDef="let element"> {{element.NmarcacionTipo}} </td>
            </ng-container>

            <ng-container matColumnDef="Fuente Marcación">
              <th mat-header-cell *matHeaderCellDef> Fuente Marcación </th>
              <td mat-cell *matCellDef="let element"> {{element.NmarcacionFuente}} </td>
            </ng-container>

            <ng-container matColumnDef="Equipo">
              <th mat-header-cell *matHeaderCellDef> Equipo </th>
              <td mat-cell *matCellDef="let element"> {{element.Nequipo}} </td>
            </ng-container>

            <ng-container matColumnDef="Estado">
              <th mat-header-cell *matHeaderCellDef> Estado </th>
              <td mat-cell *matCellDef="let element"> {{element.Nestado}} </td>
            </ng-container>

            <ng-container matColumnDef="Incidencia">
              <th mat-header-cell *matHeaderCellDef> Incidencia </th>
              <td mat-cell *matCellDef="let element"> {{element.Nincidencia}} </td>
            </ng-container>

            <ng-container matColumnDef="Foto">
              <th mat-header-cell *matHeaderCellDef> Foto </th>
              <td mat-cell *matCellDef="let element"> {{element.Foto}} </td>
            </ng-container>

            <ng-container matColumnDef="Observaciones">
              <th mat-header-cell *matHeaderCellDef> Observaciones </th>
              <td mat-cell *matCellDef="let element"> {{element.Observaciones}} </td>
            </ng-container>

            <ng-container matColumnDef="Accion">
              <th mat-header-cell *matHeaderCellDef> Acción </th>
              <td mat-cell *matCellDef="let element">
                <mat-icon [matTooltip]="'Asignar incidencia'" (click)="openModalIncidencias(element)"
                  class="ico-asignar-incidencia">assignment_add</mat-icon>
                <mat-icon matTooltip="Anular" class="icon-action-anular ml-2" *ngIf="element.IdIncidencia"
                  (click)="openModalAnularIncidencia(element)">close
                </mat-icon>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="marcacionColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: marcacionColumns;"
              [ngClass]="{'css_anulado': row.IdEstado === 0, hovered: row.hovered, sombreado: row.Seleccionado}"
              (click)="getRowData(row)" (mouseover)="row.hovered = true" (mouseout)="row.hovered = false"></tr>
          </table>
        </div>
        <mat-paginator #marcacionPaginator [pageSizeOptions]="[5, 10]"></mat-paginator>
      </div>
    </mat-tab>
    <mat-tab label="Incidencias">
      <div class="tab-contenido">
        <div class="row align-items-center">
          <div class="col-6 incidencia-selector">
            <mat-form-field class="w-100">
              <mat-label>Seleccione incidencia</mat-label>
              <mat-select panelClass="novedades-touch-select-panel" [(ngModel)]="objeto.IdIncidencia" (selectionChange)="getSeleccionIncidencia($event)">
                <mat-option *ngFor="let item of lstIncidencias" [matTooltip]="item.Detalle" [value]="item.Id">
                  {{ item.Detalle }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col incidencia-selector" *ngIf="cmbPatologiaHabilitado">
            <mat-form-field class="w-100">
              <mat-label>Seleccione patología</mat-label>
              <mat-select panelClass="novedades-touch-select-panel" [(ngModel)]="objeto.IdPatologia" (selectionChange)="getSeleccionPatologia($event)">
                <mat-option *ngFor="let item of lstPatologias" [matTooltip]="item.Detalle" [value]="item.Id">
                  {{ item.Detalle }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-12 incidencia-observaciones">
            <mat-form-field class="w-100">
              <mat-label>Observaciones</mat-label>
              <textarea matInput [(ngModel)]="objeto.Observaciones"></textarea>
            </mat-form-field>
          </div>
        </div>
        <div class="text-right barra-acciones">
          <button mat-flat-button color="primary" type="button" class="nov-btn-guardar" (click)="openModalData('incidencia')"
            [disabled]="isBtnGuardarIncidencia">Guardar</button>
        </div>
        <div class="tabla-scroll">
          <table mat-table [dataSource]="dataSourceIncidencia" class="mat-elevation-z8 table-parte-diario">
            <ng-container matColumnDef="Incidencia">
              <th mat-header-cell *matHeaderCellDef> Incidencia </th>
              <td mat-cell *matCellDef="let element"> {{element.Nincidencia}} </td>
            </ng-container>

            <ng-container matColumnDef="Estado">
              <th mat-header-cell *matHeaderCellDef> Estado </th>
              <td mat-cell *matCellDef="let element"> {{element.Nestado}} </td>
            </ng-container>

            <ng-container matColumnDef="Observaciones">
              <th mat-header-cell *matHeaderCellDef> Observaciones </th>
              <td mat-cell *matCellDef="let element"> {{element.Observaciones}} </td>
            </ng-container>

            <ng-container matColumnDef="Patologia">
              <th mat-header-cell *matHeaderCellDef> Patologia </th>
              <td mat-cell *matCellDef="let element"> {{element.Npatologia}} </td>
            </ng-container>

            <ng-container matColumnDef="Fecha Modificacion">
              <th mat-header-cell *matHeaderCellDef> Fecha Modificacion </th>
              <td mat-cell *matCellDef="let element"> {{element.FechaModificacion | date: 'dd/MM/yyyy HH:mm:ss'}}
              </td>
            </ng-container>

            <ng-container matColumnDef="nUsuario">
              <th mat-header-cell *matHeaderCellDef> Usuario </th>
              <td mat-cell *matCellDef="let element"> {{element.Nusuario}} </td>
            </ng-container>

            <ng-container matColumnDef="Id Humand">
              <th mat-header-cell *matHeaderCellDef> Id Humand </th>
              <td mat-cell *matCellDef="let element" class="text-center">
                <mat-icon *ngIf="element.IdAvisoHumand" color="primary"
                  matTooltip="ID Humand: {{ element.IdAvisoHumand }}">check</mat-icon>
              </td>
            </ng-container>

            <ng-container matColumnDef="Certificado">
              <th mat-header-cell *matHeaderCellDef> Certificado </th>
              <td mat-cell *matCellDef="let element">
                <ng-container *ngIf="element.documentos && element.documentos.length > 0">
                  <ng-container *ngFor="let doc of element.documentos">
                    <a [href]="doc" target="_blank" style="margin-right: 6px;">
                      <mat-icon color="accent">download</mat-icon>
                    </a>
                  </ng-container>
                </ng-container>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="incidenciaColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: incidenciaColumns;"
              [ngClass]="{'css_anulado': row.IdEstado === 0, hovered: row.hovered, sombreado: row.Seleccionado}"
              (mouseover)="row.hovered = true" (mouseout)="row.hovered = false"></tr>
          </table>
        </div>
        <mat-paginator #incidenciasPaginator [pageSizeOptions]="[5, 10]"></mat-paginator>
      </div>
    </mat-tab>
  </mat-tab-group>

</div>
